export default __webpack_public_path__ + "static/media/splash.369f06b7.png";